import { PublicLayout } from '../layouts/PublicLayout';
import { AppLayout } from '../layouts/AppLayout';
import { NotFoundPage } from './NotFoundPage';
import { StartPage } from './StartPage';
import { AuthSignInPage } from './AuthSignInPage';
import { PremiumPage } from './PremiumPage';
import { SubscriptionStatusPage } from './SubscriptionStatusPage';
import { ProfileSettingsPage } from './ProfileSettingsPage';
import { MainPage } from './MainPage';
import { AboutUsPage } from './AboutUsPage';
import { EmailCheckPage } from './EmailCheckPage';
import { SignInPage } from './SignInPage';
import { ReputationCheckPage } from './ReputationCheckPage';
import { BreachMonitorPage } from './BreachMonitorPage';

const pagePathnames = {
    start: '/',
    main: '/main',
    emailCheck: '/main/data-breach/email-check',
    reputationCheck: '/main/reputation-check',
    breachMonitor: '/main/breach-monitor/:id',
    authEmailSignIn: '/auth/email/sign-in',
    signIn: '/sign-in',
    premium: '/premium',
    aboutUs: '/about-us',
    profileSettings: '/profile',
    subscriptionStatus: '/subscription/:subscriptionId/status',
    notFound: '*'
};

const dynamicPagePathnames = {
    getBreachMonitor: id => `/main/breach-monitor/${id}` 
};

const pageRoutes = [
    {
        path: pagePathnames.start,
        page: StartPage,
        layout: PublicLayout,
        isProtected: false
    },
    {
        path: pagePathnames.signIn,
        page: SignInPage,
        layout: PublicLayout,
        isProtected: false
    },
    {
        path: pagePathnames.authEmailSignIn,
        page: AuthSignInPage,
        layout: PublicLayout,
        isProtected: false
    },
    {
        path: pagePathnames.notFound,
        page: NotFoundPage,
        isProtected: false
    },
    {
        path: pagePathnames.premium,
        page: PremiumPage,
        layout: AppLayout,
        isProtected: true
    },
    {
        path: pagePathnames.profileSettings,
        page: ProfileSettingsPage,
        layout: AppLayout,
        isProtected: true
    },
    {
        path: pagePathnames.main,
        page: MainPage,
        layout: AppLayout,
        isProtected: true
    },
    {
        path: pagePathnames.emailCheck,
        page: EmailCheckPage,
        layout: AppLayout,
        isProtected: true
    },
    {
        path: pagePathnames.breachMonitor,
        page: BreachMonitorPage,
        layout: AppLayout,
        isProtected: true
    },
    {
        path: pagePathnames.reputationCheck,
        page: ReputationCheckPage,
        layout: AppLayout,
        isProtected: true
    },
    {
        path: pagePathnames.aboutUs,
        page: AboutUsPage,
        layout: AppLayout,
        isProtected: true
    },
    {
        path: pagePathnames.subscriptionStatus,
        page: SubscriptionStatusPage,
        layout: PublicLayout,
        isProtected: false
    }
];

export {
    dynamicPagePathnames,
    pagePathnames,
    pageRoutes
};
